import { ReactNode } from "react";
import { Divider, Grid } from "@mui/material";

import popupStyles from "../../../../assets/styles/componentStyles/globalPopupStyles.module.scss";
import globalStyles from "../../../../assets/styles/global.module.scss";

interface ConfigurationPopupFooterProps {
    children: ReactNode;
}

const ConfigurationPopupFooter = (props: ConfigurationPopupFooterProps) => {
    const { children } = props;

    return (
        <>
            <Divider className={popupStyles.popupTitleDivider} />

            <Grid item xs={12} className={globalStyles.fullwidth}>
                <Grid container className={popupStyles.popupButtonContainer}>
                    {children}
                </Grid>
            </Grid>
        </>
    );
};

export default ConfigurationPopupFooter;